import React from 'react';
import { ListCompare } from '../components/list-compare/ListCompare';
import '../components/list-compare/ListCompare.css';

export const ListComparePage: React.FC = () => {
  return (
    <div className="page-container">
      <ListCompare />
    </div>
  );
};
